import { getEnv } from './getEnv';

export function getEnvInt(key: string) {
  return parseInt(getEnv(key), 10);
}

export default getEnvInt;
